import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_TITLE: string =
  'The Secret Soundtrack Formula For Gyms and Cafes'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_TITLE_ES: string =
  'La fórmula secreta de la banda sonora para gimnasios y cafeterías'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_TITLE_FR: string =
  'La formule secrète pour une bande-son parfaite dans les salles de sport et les cafés'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_TITLE_KO: string =
  '헬스장과 카페에서 완벽한 사운드트랙을 위한 비밀 공식'

export const SECRET_SOUNDTRACK_FORMULA_TITLE_HTML: JSX.Element = (
  <>The Secret Soundtrack Formula For Gyms and Cafes</>
)
export const SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_ES: JSX.Element = (
  <>La fórmula secreta de la banda sonora para gimnasios y cafeterías</>
)
export const SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_FR: JSX.Element = (
  <>
    La formule secrète pour une bande-son parfaite dans les salles de sport et
    les cafés
  </>
)
export const SECRET_SOUNDTRACK_FORMULA_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      헬스장과
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      카페에서
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      완벽한
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      사운드트랙을
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      위한
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      비밀
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      공식
    </span>
  </>
)

export const SECRET_SOUNDTRACK_FORMULA_PAGE_ID: string =
  '09EA5D3B-6564-40DB-AB7C-5F494EB27921'

export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE: string =
  '/articles/secret-soundtrack-formula-for-gyms-and-cafes'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES: string =
  '/articles/secret-soundtrack-formula-for-gyms-and-cafes'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR: string =
  '/articles/secret-soundtrack-formula-for-gyms-and-cafes'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO: string =
  '/articles/secret-soundtrack-formula-for-gyms-and-cafes'

export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_URL: string =
  HOST + SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_URL_ES: string =
  HOST + '/es' + SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_ES
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_URL_FR: string =
  HOST + '/fr' + SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_FR
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_URL_KO: string =
  HOST + '/ko' + SECRET_SOUNDTRACK_FORMULA_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'business music, music for gyms, music for restaurants, music for cafes, music for fitness centers, background music streaming, business background music, ambient music, licensed music, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'Música de fondo para empresas, gimnasios, restaurantes, cafeterías y centros de fitness, streaming de música de fondo, música ambiental para empresas, música ambiental, música con licencia, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "Musique d'ambiance pour entreprises, salles de sport, restaurants, cafés, centres de fitness, streaming de musique d'arrière-plan, musique d'ambiance pour entreprises, musique ambiante, musique sous licence, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '기업, 체육관, 레스토랑, 카페, 피트니스 센터를 위한 배경 음악, 배경 음악 스트리밍, 기업을 위한 주변 음악, 주변 음악, 라이선스 음악, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '81586728-830F-4446-A341-2270B9EB0656.avif'
  : HOST + '/images/81586728-830F-4446-A341-2270B9EB0656.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '81586728-830F-4446-A341-2270B9EB0656.jpg'
  : HOST + '/images/81586728-830F-4446-A341-2270B9EB0656.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'E09CBD52-283E-4325-A3B3-C4A27A09FBB1.jpg'
  : HOST + '/images/E09CBD52-283E-4325-A3B3-C4A27A09FBB1.jpg'

export const SECRET_SOUNDTRACK_FORMULA_JSON_LD_IMAGE_1200_X_1200: string =
  USE_CDN
    ? PRACTICAL_STREAM_CDN_ADDRESS + '81586728-830F-4446-A341-2270B9EB0656.png'
    : HOST + '/images/81586728-830F-4446-A341-2270B9EB0656.png'

export const ARTICLE_SUMMARY: string =
  'The most winning gyms and cafes do not entrust their background music strategy to the fate of the draw. They have found a formula that can convert sound from background noise into a driving engine of revenue that shapes customer behavior, extends visits, and builds unbreakable brand loyalty.'
export const ARTICLE_SUMMARY_ES: string =
  'Los gimnasios y cafeterías más exitosos no confían su estrategia de música ambiental al azar. Han encontrado una fórmula que puede convertir el ruido de fondo en un motor de ingresos que influye en el comportamiento del cliente, prolonga las visitas y genera una lealtad inquebrantable a la marca.'
export const ARTICLE_SUMMARY_FR: string =
  "Les salles de sport et les cafés les plus prospères ne laissent rien au hasard concernant leur musique d'ambiance. Ils ont trouvé la formule idéale pour transformer le bruit ambiant en un véritable levier de croissance, influençant le comportement des clients, prolongeant ainsi leurs visites et fidélisant durablement la clientèle."
export const ARTICLE_SUMMARY_KO: string =
  '가장 성공적인 헬스장과 카페들은 배경 음악에 있어서 어떤 것도 우연에 맡기지 않습니다. 그들은 주변 소음을 진정한 성장 동력으로 전환하여 고객 행동에 영향을 미치고, 방문 기간을 늘리고, 지속적인 고객 충성도를 구축하는 완벽한 공식을 찾아냈습니다.'

export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR: string =
  '2025-11-20'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_CREATED_STR: string =
  '2025-11-20'
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED: Date = new Date(
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_PUBLISHED_STR
)
export const SECRET_SOUNDTRACK_FORMULA_ARTICLE_CREATED: Date = new Date(
  SECRET_SOUNDTRACK_FORMULA_ARTICLE_CREATED_STR
)
